import { classNames } from 'primereact/utils';
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
  useEffect,
} from 'react';
import { AppTopbarRef } from 'src/types';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { Dropdown } from 'primereact/dropdown';
import { languages } from 'src/i18n/languages';

// const languages = [
//   { label: "English", value: "en" },
//   { label: "Bahasa Melayu", value: "ms" }
// ];

interface AppTopbarProps {
  onNavClick?: (id: string) => void;
}

const AppTopbar = forwardRef<AppTopbarRef, AppTopbarProps>((props, ref) => {
  const { t } = useTranslation();
  const topbarmenuRef = useRef<HTMLDivElement>(null);
  const topbarmenubuttonRef = useRef<HTMLButtonElement>(null);
  const [isMobileMenuActive, setIsMobileMenuActive] = useState(false);

  useImperativeHandle(ref, () => ({
    topbarmenu: topbarmenuRef.current,
    topbarmenubutton: topbarmenubuttonRef.current,
  }));

  const toggleMobileMenu = () => setIsMobileMenuActive((prev) => !prev);

  // Menu items
  const menuItems = [
    { label: 'Industries', id: 'solutions' },
    { label: 'Key Capabilities', id: 'discover' },
    { label: 'Blog Search', id: 'blog-search', isButton: true },
    //{ label: 'EN', id: 'home', isButton: false, icon: 'pi pi-globe' },
  ];

  const [currentLang, setCurrentLang] = useState(i18n.language);

  useEffect(() => {
    const handleLanguageChanged = (lng: string) => setCurrentLang(lng);
    i18n.on('languageChanged', handleLanguageChanged);
    return () => i18n.off('languageChanged', handleLanguageChanged);
  }, []);


  return (
    <div className="layout-topbar-wrapper">
      {/* Topbar */}
      <div className="layout-topbar flex fixed w-full z-50 justify-content-between flex-wrap">
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });

            setTimeout(() => {
              window.location.href = '/';
            }, 100);
          }}
          className="relative inline-block"
        >
          <img
            src="/assets/layout/images/logo-6.png"
            alt="logo"
            style={{ width: '200px' }}
          />
        </a>

        <div className="hidden lg:flex gap-3">
          <Button
            text
            className='text-white'
            label={t('header.faqs')}
            onClick={() => props.onNavClick?.('faq')}
          />

          <Dropdown
            value={currentLang}
            options={languages}
            onChange={(e) => {
              i18n.changeLanguage(e.value);
              console.log("Selected language:", e.value); // log selected lang
            }}
            placeholder={t("common.selectLanguage")}
            // style={{ width: "150px" }}
            className="minimal-dropdown"
          />



        </div>

        {/* Mobile Hamburger */}
        <button
          ref={topbarmenubuttonRef}
          type="button"
          className="p-link layout-topbar-menu-button layout-topbar-button lg:hidden"
          onClick={toggleMobileMenu}
        >
          <i
            className={classNames(
              'pi text-2xl transition-transform duration-300',
              isMobileMenuActive ? 'pi-times rotate-90' : 'pi-bars'
            )}
          />
        </button>
      </div>

      {/* Mobile Menu */}
     {/* Mobile Menu */}
<div
  ref={topbarmenuRef}
  className={classNames(
    'lg:hidden bg-white w-full shadow-md fixed left-0 overflow-hidden transition-all duration-300 z-40',
    {
      'max-h-96 opacity-100': isMobileMenuActive, // visible menu
      'max-h-0 opacity-0': !isMobileMenuActive,   // hidden menu
    }
  )}
  style={{ top: '80px' }}
>
  <div className="flex flex-col px-2 py-2 gap-2 surface-100">
    <Button
      text
      className='text-white'
      label={t('header.faqs')}
      onClick={() => props.onNavClick?.('faq')}
    />

    <Dropdown
      value={currentLang}
      options={languages}
      onChange={(e) => i18n.changeLanguage(e.value)}
      placeholder={t("common.selectLanguage")}
      className="minimal-dropdown w-full"
    />
  </div>
</div>
    </div>
  );
});

AppTopbar.displayName = 'AppTopbar';
export default AppTopbar;
